import { usePermissions } from "@/lib/hooks/use-permissions";
import { 
  PageLayout, 
  PageHeader, 
  PageTitle, 
  PageNav, 
  PageNavItem 
} from "@/util-components/page-layout";
import { Zap, Image, ShoppingBag } from "lucide-react";
import { useCallback } from "react";

/**
 * Main post generator page with clean, minimal design
 * Provides navigation between templates and media library sections
 */
function PostGenerator() {
  const { isInternal, isCustomer } = usePermissions();
  
  // Custom redirect logic for Post Generator
  const resolveDefaultTab = useCallback(() => {
    if (isInternal) {
      return 'store';
    } else {
      return 'start';
    }
  }, [isInternal]);

  return (
    <PageLayout 
      basePath="/post-generator" 
      resolveDefaultTab={resolveDefaultTab}
      suspenseType="blue"
    >
      <PageHeader data-onboarding="post-generator-page-header">
        <PageTitle 
          title="Post Generator" 
          icon={Zap} 
          iconColor="text-blue-600" 
          iconBg="bg-blue-50" 
        />
        
        <PageNav>
          <PageNavItem 
            value="start" 
            label="Startseite" 
            icon={Zap} 
            show={isCustomer}
          />
          <PageNavItem 
            value="store" 
            label="Template Store" 
            icon={ShoppingBag} 
          />
          <PageNavItem 
            value="media-library" 
            label="Mediathek" 
            icon={Image} 
          />
        </PageNav>
      </PageHeader>
    </PageLayout>
  );
}

export default PostGenerator;
